import { render, staticRenderFns } from "./TaxSettingsNotification.vue?vue&type=template&id=84453350&scoped=true&"
import script from "./TaxSettingsNotification.vue?vue&type=script&lang=ts&"
export * from "./TaxSettingsNotification.vue?vue&type=script&lang=ts&"
import style0 from "./TaxSettingsNotification.vue?vue&type=style&index=0&id=84453350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84453350",
  null
  
)

export default component.exports